import { render, staticRenderFns } from "./AddLockupsDialog.vue?vue&type=template&id=781ac888&scoped=true&"
import script from "./AddLockupsDialog.vue?vue&type=script&lang=js&"
export * from "./AddLockupsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781ac888",
  null
  
)

export default component.exports